import { render, staticRenderFns } from "./BasisListWrapper.vue?vue&type=template&id=9f4ff7fc&scoped=true&"
import script from "./BasisListWrapper.vue?vue&type=script&lang=js&"
export * from "./BasisListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BasisListWrapper.vue?vue&type=style&index=0&id=9f4ff7fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4ff7fc",
  null
  
)

export default component.exports